import { FC } from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Link } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation, useNavigate } from "react-router-dom";
import MarkdownRenderer from "./MarkdownRenderer";

interface Props {
  title: string;
  content: string;
  ariaControls: string;
  id: string;
  defaultExpanded?: boolean;
  sectionId?: string;
}

const SummaryAccordion: FC<Props> = ({
  title,
  content,
  ariaControls,
  id,
  defaultExpanded = false,
  sectionId
}) => {
  const navState = useLocation();
  const navigate = useNavigate();

  const handleViewDetails = () => {
    const currentState = navState.state;
    const mmhId = currentState?.mmhId;

    navigate(`/subscriberInfo/details?mmh_id=${mmhId}`, {
      state: {
        scanMethod: currentState?.scanMethod,
        registerId: currentState?.registerId,
        scrollTo: sectionId
      },
    });
  };
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      sx={{ boxShadow: 'none', border: 'none', '&:before': { display: 'none' } }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={ariaControls}
        id={id}
        sx={{
          backgroundColor: "transparent",
          "& .MuiAccordionSummary-content": {
            margin: "12px 0",
          },
        }}
      >
        <Typography
          variant="h6"
          fontWeight={600}
          fontSize={18}
          color="#000"
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "0 16px 16px 16px" }}>
        <Box>
          {content ? (
            <MarkdownRenderer content={content} />
          ) : (
            <Typography
              variant="body1"
              fontSize={14}
              lineHeight={1.5}
              color="#999"
              textAlign="center"
              fontStyle="italic"
            >
              No Info provided
            </Typography>
          )}

          {sectionId && (
            <Box sx={{ mt: 2, textAlign: "right" }}>
              <Link
                component="button"
                onClick={handleViewDetails}
                sx={{
                  color: "#000094",
                  textDecoration: "underline",
                  fontSize: "14px",
                  fontWeight: 500,
                  cursor: "pointer",
                  "&:hover": {
                    color: "#000080",
                  },
                }}
              >
                View Details →
              </Link>
            </Box>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default SummaryAccordion;